<div class="sidebar included">
	<app-sidebar-header [title]="'ancillaries.group.HANDB' | ibeadmin: 'sync'"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>

		<app-flight-route [flight]="flight" *ngIf="flight"></app-flight-route>

		<div class="sidebar__header-image" [style.background-image]="INDRA_printImage()"></div>
		<app-included-per-passenger [flight]="flight" [brand]="brand" [feature]="feature" [passengers]="passengerList" [personalItem]="personalItemAllowanceText" *ngIf="flight">
		</app-included-per-passenger>
		<div class="sidebar-flight-text border">
			<h2 class="title-h2">
				{{ 'whatsIncludedSidebars.detailsHandLuggage.text.handLuggageAllowance' | ibeadmin: 'sync' }}
			</h2>
			<div class="sidebar-flight-text no-padding">
				<h5 class="bold max-weight-dimension">
					{{ 'whatsIncludedSidebars.detailsHandLuggage.text.maxWeightAndDimension' | ibeadmin: 'sync' }}
				</h5>
				<p class=""> 
					{{ baggageAllowanceText | ibeadmin: 'sync' }} 
				</p>
				<p *ngIf="personalItemAllowanceText" class=""> 
					{{ personalItemAllowanceText | ibeadmin: 'sync' }}
				</p>
				<!-- <p class="">Baby Allowance - up to 10kg</p> -->
			</div>
			<!-- <div class="sidebar-flight-text ">
				<h5 class="bold">
					{{ 'whatsIncludedSidebars.detailsHandLuggage.title.maximumDimension' | ibeadmin: 'sync' }}
				</h5>
				<p class="">
					{{ 'whatsIncludedSidebars.detailsHandLuggage.text.maximumDimension0' | ibeadmin: 'sync' }}
				</p>
			</div> -->
			<div class="sidebar-flight-text ">
				<p>
					{{'whatsIncludedSidebars.detailsHandLuggage.text.checkCabinBag' | ibeadmin:'sync'}}
				</p>
			</div>
			<div class="sidebar-flight-text ">
				<p>
					{{'whatsIncludedSidebars.detailsHandLuggage.text.oversizeCharge' | ibeadmin:'sync'}}
				</p>
			</div>
			<div class="sidebar-flight-text ">
				<a (click)="INDRA_gotoURL('externalURLs.aboutHandBaggage')"
					href="javascript:;"
					class="link extras-feature__link link--external" 
					aria-label="Open a dialog to hand baggage rules and restrictions, opens new window">
					{{ 'whatsIncludedSidebars.detailsHandLuggage.button.rulesAndRestrictions' | ibeadmin: 'sync' }}
				</a>
			</div>
		</div>

		<app-compare-brands [feature]="feature" [brand]="brand" *ngIf="!reviewFlights && !timeToThinkFlights"></app-compare-brands>
		<div class="extras__helper with-notification">
			<div class="">
				<a class="link extras-feature__link" 
					aria-label="Close dialog"
					(click)="INDRA_handleClose()" 
					href="javascript:;" 
					role="button">
					{{ 'whatsIncludedSidebars.general.text.closeWindow' | ibeadmin: 'sync' }}
				</a>
			</div>
		</div>
	</div>
	<div #sidebar__footer class="sidebar__footer "></div>
</div>
